var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"colorbc"},[_c('lines'),_c('div',{staticClass:"project_container"},[_c('Firstsection'),_c('Secondsection'),_c('thirdSection'),_c('forthsection')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }